import axios from 'axios';
import { useQuery } from 'react-query';

export default function useFindAllIdCards() {
  const { data, isLoading, error } = useQuery('idCards', async () => {
    const fetchedData = await axios.get('/idcards');
    if (Array.isArray(fetchedData.data)) {
      return fetchedData.data;
    } else {
      console.warn('Fetching id cards did not return array');
      return [];
    }
  });

  return {
    idCards: data,
    isLoading: isLoading,
    error,
  };
}
